import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { EventService } from 'src/app/services/events/event.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { PACKAGE_TYPE, Purchases, PurchasesOffering, PurchasesPackage } from '@revenuecat/purchases-capacitor';
import { SubscriptionStatus } from 'src/app/services/subscription-service/subscription.service';
import { PromptService } from 'src/app/services/promtp-service/prompt.service';
import { TranslatorService } from 'src/app/services/translator-service/translator.service';
import { LoadingService } from 'src/app/services/loading-service/loading.service';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-paywall-popup',
  standalone: true,
  templateUrl: './paywall-popup.component.html',
  styleUrls: ['./paywall-popup.component.scss'],
  imports: [CommonModule, IonicModule, SharedModule],
})
export class PaywallPopupComponent implements OnInit, OnDestroy {
  @Input() offerings: PurchasesOffering | null = null;
  @Input() isSubscribed = false;
  @Input() subscriptionStatus: SubscriptionStatus | null = null;

  busyLoading = false;
  busySubscribing = false;
  selectedPackageIdentifier: string | null = null;
  mostPopularIdentifier: string | null = null;
  private subs: Subscription[] = [];
   privacyPolicyUrl:string = environment.privacyPolicy;
    termsOfUseURL: string = environment.termsOfUse;

  constructor(private modalCtrl: ModalController,
    private _promptService: PromptService,
    private _TranslatorService: TranslatorService
  ) {
    this.subs.push(
      EventService.loadingEvent.subscribe((val) => {
        this.busyLoading = val > 0;
      })
    );
  }

  ngOnInit(): void {
    if (this.offerings && this.offerings?.availablePackages?.length > 0) {
      const sortedPackages = [...this.offerings.availablePackages].sort((a: any, b: any) => {
        const priceA = a?.product?.price ?? 0;
        const priceB = b?.product?.price ?? 0;
        return priceB - priceA; // descending
      });

      this.selectedPackageIdentifier = sortedPackages[0]?.identifier;
      this.mostPopularIdentifier = sortedPackages[0]?.identifier;
    }


  }
  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  getSelectedPackage() {
    return this.offerings?.availablePackages.find(
      (pkg: PurchasesPackage) => pkg.identifier === this.selectedPackageIdentifier
    );
  }

  selectPackage(pkgId: string) {
    if (!this.busyLoading) {
      this.selectedPackageIdentifier = pkgId;
    }
  }

  async subscribe(pkg?: PurchasesPackage) {
    if (this.isSubscribed || !pkg) return;

    const loadingURL = 'https://paycat/subscribe';
    LoadingService.setLoading(true, loadingURL);

    setTimeout(async () => {
      try {
        const result = await Purchases.purchasePackage({ aPackage: pkg });

        const active = result?.customerInfo?.entitlements?.active;
        LoadingService.setLoading(false, loadingURL);
        if (active && Object.keys(active).length > 0) {
          this.isSubscribed = true;
         
        }
      } catch (error) {
        await this.dismissWithResult(false);
      }
      finally {
        await this.dismissWithResult(this.isSubscribed);
      }

    }, 5);

  }

  async dismissWithResult(result: boolean) {
    if(!result)
      await this.modalCtrl.dismiss({ success: result }, 'cancelled', 'paywall-modal');
    else
    await this.modalCtrl.dismiss({ success: result }, 'success', 'paywall-modal');
  }

  get disclaimerText(): string {
    let disclaimer = "";

    let pkg = this.getSelectedPackage();
    if (pkg) {      
      disclaimer = "A " + pkg.product.priceString; 
      if(pkg.packageType == PACKAGE_TYPE.MONTHLY){
        disclaimer = disclaimer + " " +  this._TranslatorService.translateText('paywall-popup.monthly');
      }
      if(pkg.packageType == PACKAGE_TYPE.THREE_MONTH){
        disclaimer = disclaimer + " " +  this._TranslatorService.translateText('paywall-popup.three-month');
      }
      if(pkg.packageType == PACKAGE_TYPE.ANNUAL){
        disclaimer = disclaimer + " " +  this._TranslatorService.translateText('paywall-popup.annual');
      }
    }


    if (Capacitor.getPlatform() == "android")
      disclaimer += ' ' +this._TranslatorService.translateText('paywall-popup.disclaimer-text-1-google');
    else
      disclaimer += ' ' + this._TranslatorService.translateText('paywall-popup.disclaimer-text-1-apple');


  
    return disclaimer;
  }

  async openUrl(theUrl: string) {
    setTimeout(async () => {
      await Browser.open({ url: theUrl });
    }, 10)
  }



}